import React from 'react'
import { Card, CardBody, Col, Table } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList } from '../../../../Data/DashboardsData/ECommerceData'
import { CustomerSupportSummary } from '../../../../Utils/Constants'
import { sellingProductData } from '../../../../Data/DashboardsData/DefaultData'
import { H5, Image, ProgressBar } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'
import { Link } from 'react-router-dom'

export default function SellingProduct() {
    return (
        <Col xl={6}>
            <Card className="selling-product">
                <DropdownWithHeader headerClass='pb-0' heading={CustomerSupportSummary}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    <div className="table-responsive custom-scrollbar">
                        <Table className="display">
                            <thead>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Customer</th>
                                    <th>Progress</th>
                                    <th>Total</th>
                                    <th>Shipping</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sellingProductData.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <div className="d-flex">
                                                <Image src={dynamicImage(`dashboard/product/${item.image}`)} alt="" />
                                                <div className="flex-grow-1 ms-2">
                                                    <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product-list`}>
                                                        <span>{item.name}</span>
                                                        <H5>{item.subText}</H5>
                                                    </Link>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span>{item.customer}</span>
                                            <h5>{item.email}</h5>
                                        </td>
                                        <td>
                                            <div className="progress-showcase">
                                                <ProgressBar className={`sm-progress-bar progress-border-${item.progressColor}`} value={item.progressValue} />
                                            </div>
                                        </td>
                                        <td>$ {item.total}</td>
                                        <td>$ {item.shipping}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}